export default "__VITE_ASSET__OUxDc4wU__"